import { Title } from '../../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial mediastino;</li>
                            <li>Coronal mediastino;</li>
                            <li>Sagital mediastino;</li>
                            <li>Axial pulmão;</li>
                            <li>Coronal pulmão;</li>
                            <li>Sagital pulmão;</li>
                            <li>Axial MIP;</li>
                            <li>Coronal MIP;</li>
                            <li>Coronal Min IP;</li>
                            <li>3D Pulmões;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}